export default function cyrillicToLatin(string: string): string {
  const ru: Record<string, string> = {
    а: 'a',
    б: 'b',
    в: 'v',
    г: 'g',
    д: 'd',
    е: 'e',
    ё: 'e',
    ж: 'j',
    з: 'z',
    и: 'i',
    й: 'i',
    к: 'k',
    л: 'l',
    м: 'm',
    н: 'n',
    о: 'o',
    п: 'p',
    р: 'r',
    с: 's',
    т: 't',
    у: 'u',
    ф: 'f',
    х: 'h',
    ц: 'c',
    ч: 'ch',
    ш: 'sh',
    щ: 'shch',
    ы: 'y',
    э: 'e',
    ю: 'yu',
    я: 'ya',
    ъ: 'y',
    ь: '',
  }

  return string
    .split('')
    .map((char) => {
      if (char === 'ь') return
      if (ru[char]) {
        return ru[char]
      }

      if (ru[char.toLowerCase()]) {
        return ru[char.toLowerCase()].toUpperCase()
      }

      return char
    })
    .join('')
}
